import React from "react";
import moment from "moment";
import { Table } from "antd";
import CountryTableCell from "./CountryTableCell";
import AnchorTableCell from "../shared/AnchorTableCell/AnchorTableCell";
const { Column } = Table;

const ReferringDomainsTable = ({ dataSource }) => {
  return (
    <Table dataSource={dataSource} pagination={false} size="small" data-cy="referring-domains-table">
      <Column title="#" dataIndex="key" align="left" />
      <Column
        className="no-wrap"
        title="Domain"
        dataIndex="domain"
        render={(_, record) => <AnchorTableCell url={`http://${record["domain"]}`} anchor={record["domain"]} />}
      />
      <Column
        title="Country"
        dataIndex="country_name"
        render={(_, record) => <CountryTableCell code={record["country"]} name={record["country_name"]} />}
      />
      <Column
        className="no-wrap al-right"
        title="Backlinks Number"
        dataIndex="backlinks_num"
        render={(_, record) => parseInt(record["backlinks_num"]).toLocaleString()}
      />
      <Column className="no-wrap al-right" title="Domain Score" dataIndex="domain_score" />
      <Column
        className="no-wrap al-right"
        title="First Seen"
        dataIndex="first_seen"
        render={(_, record) => moment.unix(record["first_seen"]).format("MMM DD, YYYY")}
      />
      <Column
        className="no-wrap al-right"
        title="Last Seen"
        dataIndex="last_seen"
        render={(_, record) => moment.unix(record["last_seen"]).format("MMM DD, YYYY")}
      />
    </Table>
  );
};

export default ReferringDomainsTable;
